var link_viewer_default = {
  "fontElementMap": "wJNA6",
  "link": "vs-VF",
  "linkInEditor": "Ue1wH",
  "linkInViewer": "efNGO",
  "toolbarUrlContainer": "IEcsH",
  "toolbarUrl": "Qdocm",
  "toolbarUrlAnchor": "s6mfp"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
